import { DateTime } from 'luxon';
import { FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

export function registerValueChangeHandlers(dynFormGroup: FormGroup, isFormSubmitted: boolean, setFundingSourcesInFormData: (mData: any) => void) {
  dynFormGroup.get('ArethereanylimitationsontheneedforSTS?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data === 'No') {
          dynFormGroup.controls['ifYesLimitations'].disable();
          dynFormGroup.controls['ifYesLimitations'].setValue('');
        } else {
          dynFormGroup.controls['ifYesLimitations'].enable();
        }
      }
    });

  dynFormGroup.get('DoestheClientmeettherequirementforassistancewithmedicaltransportation?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data === 'Yes') {
          dynFormGroup.controls['ifNoWhy?'].setValue('');
          dynFormGroup.controls['ifNoWhy?'].disable();
        } else {
          dynFormGroup.controls['ifNoWhy?'].enable();
        }
      }
    });

  dynFormGroup.get('DoestheClientneedtobetransportedtoaprovideroutsideofthecountyonaroutinebasis?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data === 'No') {
          dynFormGroup.controls['ifSoWhy?'].setValue('');
          dynFormGroup.controls['ifSoWhy?'].disable();
        } else {
          dynFormGroup.controls['ifSoWhy?'].enable();
        }
      }
    });

  dynFormGroup.get('Canyoucontinueusingthatmethodoftransportation?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data === 'Yes') {
          dynFormGroup.controls['ifno,whynot?'].setValue('');
          dynFormGroup.controls['ifno,whynot?'].disable();
        } else {
          dynFormGroup.controls['ifno,whynot?'].enable();
        }
      }
    });

  dynFormGroup.get('Haveyouappliedforspecialtransportationservices(STS)?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data === 'No') {
          dynFormGroup.controls['ifYesApplication'].setValue('');
          dynFormGroup.controls['ifYesApplication'].disable();
        } else {
          dynFormGroup.controls['ifYesApplication'].enable();
        }
      }
    });

  dynFormGroup.get('areyoureceivingdisabilitybenefit?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data === 'No') {
          let result: any = [];
          dynFormGroup.controls['ifYesDisability'].value.forEach(() => {
            result.push(false);
          });
          dynFormGroup.controls['ifYesDisability'].setValue(result);
          dynFormGroup.controls['ifYesDisability'].disable();
        } else {
          dynFormGroup.controls['ifYesDisability'].enable();
        }
      }
    });

  dynFormGroup.get('Howareyougettingtothestoreandappointments?')
    ?.valueChanges.subscribe((data) => {
      if (data) {
        if (data?.includes('Other Agency')) {
          dynFormGroup.controls['agencyName']?.enable();
        } else {
          dynFormGroup.controls['agencyName']?.setValue('');
          dynFormGroup.controls['agencyName']?.disable();
        }
      }
    });

  dynFormGroup.get('fundingSource')
    ?.valueChanges.subscribe((mData) => {
      if (mData && !isFormSubmitted) {
        setFundingSourcesInFormData(mData);
      }
    });
}
export function registerDateAndAddressValueChangeHandlers(
  dynFormGroup: FormGroup,
  context: any
) {
  dynFormGroup.controls['from']?.disable();
  dynFormGroup.controls['to']?.disable();
  dynFormGroup.controls['from']?.removeValidators(Validators.required);
  dynFormGroup.controls['to']?.removeValidators(Validators.required);

  dynFormGroup
    .get('from')
    ?.valueChanges.subscribe(() => {
      context.isValidateDate = true;
      const fromValue = dynFormGroup.controls['from']?.value;
      const toValue = dynFormGroup.controls['to']?.value;
      if (
        fromValue &&
        toValue &&
        DateTime.fromJSDate(new Date(fromValue)).toFormat('yyyy-MM-dd') >
        DateTime.fromJSDate(new Date(toValue)).toFormat('yyyy-MM-dd')
      ) {
        dynFormGroup.controls['to']?.setErrors({ pattern: true });
      } else {
        dynFormGroup.controls['to']?.setErrors({ pattern: false });
        dynFormGroup.controls['to']?.setErrors(null);
      }
    });

  dynFormGroup
    .get('fromNonMedicaidDate')
    ?.valueChanges.subscribe(() => {
      context.isValidateNonMedicaidDate = true;
      const fromNonMedicaid = dynFormGroup.controls['fromNonMedicaidDate']?.value;
      const toNonMedicaid = dynFormGroup.controls['toNonMedicaidDate']?.value;
      if (
        fromNonMedicaid &&
        toNonMedicaid &&
        DateTime.fromJSDate(new Date(fromNonMedicaid)).toFormat('yyyy-MM-dd') >
        DateTime.fromJSDate(new Date(toNonMedicaid)).toFormat('yyyy-MM-dd')
      ) {
        dynFormGroup.controls['toNonMedicaidDate']?.setErrors({ pattern: true });
      } else {
        dynFormGroup.controls['toNonMedicaidDate']?.setErrors({ pattern: false });
        dynFormGroup.controls['toNonMedicaidDate']?.setErrors(null);
      }
    });

  dynFormGroup
    .get('isApplicantEligibleForMedicaid?')
    ?.valueChanges.subscribe((data) => {
      if (
        data?.toLowerCase() === 'yes' &&
        context.currentFormIndex == 0 &&
        dynFormGroup.controls['medicaid']?.value != ''
      ) {
        dynFormGroup.controls['from']?.enable();
        dynFormGroup.controls['to']?.enable();
        dynFormGroup.controls['from'].addValidators(Validators.required);
        dynFormGroup.controls['to'].addValidators(Validators.required);
        context.isValidateDate = true;
      } else {
        dynFormGroup.controls['isApplicantEligibleForMedicaid']?.disable();
        dynFormGroup.controls['from']?.setValue('');
        dynFormGroup.controls['from']?.disable();
        dynFormGroup.controls['to']?.setValue('');
        dynFormGroup.controls['from'].removeValidators(Validators.required);
        dynFormGroup.controls['to'].removeValidators(Validators.required);
        dynFormGroup.controls['to']?.disable();
        context.isValidateDate = false;
      }
    });

  dynFormGroup
    .get('sameAsHomeAddress')
    ?.valueChanges.subscribe((data) => {
      if (data && data[0]) {
        dynFormGroup.controls['MailingAddress']?.disable();
        dynFormGroup.controls['MailingCity']?.disable();
        dynFormGroup.controls['MailingState']?.disable();
        dynFormGroup.controls['MailingZipCode']?.disable();
        context.patchMailingAddress();
      } else if (data && !data[0] && context.currentFormIndex == 0) {
        dynFormGroup.controls['MailingAddress']?.enable();
        dynFormGroup.controls['MailingCity']?.enable();
        dynFormGroup.controls['MailingState']?.enable();
        dynFormGroup.controls['MailingZipCode']?.enable();
      }
    });
}
export function validateNonMedicaidDateUtil(
  dynFormGroup: FormGroup,
  toastr: ToastrService,
  onSubmit: (param: any, label?: any) => void,
  label: any,
  fromDate: any,
  toDate: any
) {
  if (fromDate && toDate) {
    if (fromDate >= toDate) {
      dynFormGroup.controls['toNonMedicaidDate'].markAsTouched();
      dynFormGroup.controls['toNonMedicaidDate'].setErrors({ pattern: true });
      toastr.error(`To date should be greater than from date`, '', {
        timeOut: 1000,
      });
    } else {
      onSubmit('', label);
    }
  } else {
    if (!fromDate && !toDate) {
      toastr.error(`Please enter valid from & to dates`, '', {
        timeOut: 1000,
      });
    } else if (!fromDate) {
      toastr.error(`Please enter valid from date`, '', {
        timeOut: 1000,
      });
    } else if (!toDate) {
      toastr.error(`Please enter valid to date`, '', {
        timeOut: 1000,
      });
    }
  }
}

// Utility function for validating Medicaid Date
export function validateMedicaidDateUtil(
  dynFormGroup: FormGroup,
  toastr: ToastrService,
  onSubmit: (param: any, label?: any) => void,
  label: any,
  fromDate: any,
  toDate: any
) {
  if (fromDate && toDate) {
    if (fromDate >= toDate) {
      dynFormGroup.controls['to'].setErrors({ pattern: true });
      toastr.error(`To date should be greater than from date`, '', {
        timeOut: 1000,
      });
    } else {
      onSubmit('', label);
    }
  } else {
    if (!fromDate && !toDate) {
      dynFormGroup.controls['from'].setErrors({ required: true });
      dynFormGroup.controls['to'].setErrors({ required: true });
      dynFormGroup.controls['from'].markAsTouched();
      dynFormGroup.controls['to'].markAsTouched();
      toastr.error(`Please Enter From Date and To Date`, '', {
        timeOut: 1000,
      });
    } else if (!fromDate) {
      dynFormGroup.controls['from'].setErrors({ required: true });
      dynFormGroup.controls['from'].markAsTouched();
      toastr.error(`Please Enter From Date`, '', {
        timeOut: 1000,
      });
    } else if (!toDate) {
      dynFormGroup.controls['to'].setErrors({ required: true });
      dynFormGroup.controls['to'].markAsTouched();
      toastr.error(`Please Enter To Date`, '', {
        timeOut: 1000,
      });
    }
  }
}
export function setNonMedicaidDatesUtil(dynFormGroup: any, context: any) {
  let toDate = DateTime.local().plus({ years: 1 }).toFormat('yyyy-MM-dd');
  dynFormGroup.controls['fromNonMedicaidDate']?.enable();
  dynFormGroup.controls['toNonMedicaidDate']?.enable();

  if (!dynFormGroup.controls['fromNonMedicaidDate'].value) {
    dynFormGroup.controls['fromNonMedicaidDate'].setValue(DateTime.local().toFormat('yyyy-MM-dd'));
  }
  if (!dynFormGroup.controls['toNonMedicaidDate'].value) {
    dynFormGroup.controls['toNonMedicaidDate'].setValue(toDate);
  }
  context.isValidateNonMedicaidDate = true;
}

// Handles the main onNext logic for the application form's navigation and validation
export function onNextSectionUtil(context: any, label?: any) {
  if (context.currentFormIndex === 0) {
    let fromDate = context.dynFormGroup.controls['from'].value
      ? new Date(context.dynFormGroup.controls['from'].value)
      : null;
    let toDate = context.dynFormGroup.controls['to'].value
      ? new Date(context.dynFormGroup.controls['to'].value)
      : null;
    context.fromDate = fromDate;
    context.toDate = toDate;
    if (context.isValidateDate) {
      context.validateMedicaidDate(label, fromDate, toDate);
    } else if (!context.dynFormGroup.controls['DateOfBirth']?.value) {
      context.dynFormGroup.controls['DateOfBirth'].markAsTouched();
      context.dynFormGroup.controls['DateOfBirth'].setErrors({ required: true });
      context.toastr.error(`Date of Birth is required`, '');
    } else {
      context.onSubmit('', label);
    }
  } else if (context.currentFormIndex == 3) {
    let subformIndex = context.formData?.form?.subforms[3]?.subform_sections.findIndex(
      (subForm: any) => subForm.section_name === 'Funding Sources'
    );
    let selectedValues: boolean[] = [];
    selectedValues =
      context.formData?.form?.subforms[3]?.subform_sections[subformIndex]?.fields[0]?.selected_values;
    if (!selectedValues) {
      context.toastr.error(`Please Select At least one Funding Source`, '', {
        timeOut: 1000,
      });
    } else if (selectedValues) {
      let checker =
        Array.isArray(selectedValues[0]) &&
        selectedValues[0]?.some((item: any) => item);
      if (!checker) {
        context.toastr.error(`Please Select At least one Funding Source`, '', {
          timeOut: 1000,
        });
      } else if (context.isValidateNonMedicaidDate) {
        let fromNonMedicaidDate = context.dynFormGroup.controls['fromNonMedicaidDate'].value
          ? new Date(context.dynFormGroup.controls['fromNonMedicaidDate'].value)
          : null;
        let toNonMedicaidDate = context.dynFormGroup.controls['toNonMedicaidDate'].value
          ? new Date(context.dynFormGroup.controls['toNonMedicaidDate'].value)
          : null;
        context.fromNonMedicaidDate = fromNonMedicaidDate;
        context.toNonMedicaidDate = toNonMedicaidDate;
        context.validateNonMedicaidDate(label, fromNonMedicaidDate, toNonMedicaidDate);
      } else {
        context.onSubmit('', label);
      }
    }
  } else {
    context.onSubmit('', label);
  }
}

// Utility to populate form fields from applicant details
export function populateFormFieldsUtil(dynFormGroup: any, applicantDetails: any) {
  dynFormGroup.controls['ContactPrimaryType']?.patchValue(['Mobile']);
  dynFormGroup.controls['MailingAddress']?.setValue(applicantDetails.mailing_street || '');
  dynFormGroup.controls['MailingCity']?.setValue(applicantDetails.mailing_city || '');
  dynFormGroup.controls['MailingState']?.setValue([applicantDetails.mailing_state]);
  dynFormGroup.controls['MailingZipCode']?.setValue(applicantDetails.mailing_postcode || '');
  dynFormGroup.controls['Last4OfSocial']?.setValue(applicantDetails.SSN4 || '');
  dynFormGroup.controls['PersonalID(PID)']?.setValue(applicantDetails?.extra2);
  dynFormGroup.controls['sisid']?.setValue(applicantDetails?.extra3);
  dynFormGroup.controls['medicaid']?.setValue(applicantDetails?.medicaid_number || '');

  if (dynFormGroup.get('medicaid')?.value === '') {
    dynFormGroup.controls['isApplicantEligibleForMedicaid?']?.disable();
  }
  else if (dynFormGroup.get('medicaid')?.value !== '') {
    dynFormGroup.controls['isApplicantEligibleForMedicaid?']?.enable();
    dynFormGroup.controls['isApplicantEligibleForMedicaid?']?.setValue('No');
  }
}